"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.addonCloudflare = exports.useHostingAdvancedServer = exports.getHostingAdvancedServerQueryKey = exports.hostingAdvancedServer = exports.useHostingAddons = exports.getHostingAddonsQueryKey = exports.hostingAddons = exports.useAddonsInfo = exports.getAddonsInfoQueryKey = exports.addonsInfo = exports.useAddonsCloudflare = exports.addonsCloudflare = exports.useAddonsSitelockSso = exports.getAddonsSitelockSsoQueryKey = exports.addonsSitelockSso = exports.useCodeguardWebsiteBackupRestore = exports.codeguardWebsiteBackupRestore = exports.useCodeguardWebsiteBackupCreate = exports.codeguardWebsiteBackupCreate = exports.useCodeguardWebsiteBackupList = exports.getCodeguardWebsiteBackupListQueryKey = exports.codeguardWebsiteBackupList = exports.useCodeguardWebsiteList = exports.getCodeguardWebsiteListQueryKey = exports.codeguardWebsiteList = exports.useCodeguardPlanInfo = exports.getCodeguardPlanInfoQueryKey = exports.codeguardPlanInfo = exports.useCodeguardLoginLink = exports.getCodeguardLoginLinkQueryKey = exports.codeguardLoginLink = exports.useCodeguardDatabaseBackupRestore = exports.codeguardDatabaseBackupRestore = exports.useCodeguardDatabaseBackupCreate = exports.codeguardDatabaseBackupCreate = exports.useCodeguardDatabaseBackupList = exports.getCodeguardDatabaseBackupListQueryKey = exports.codeguardDatabaseBackupList = exports.useCodeguardDatabaseList = exports.getCodeguardDatabaseListQueryKey = exports.codeguardDatabaseList = exports.useCodeguardBackupRestore = exports.codeguardBackupRestore = exports.useCodeguardBackupDownload = exports.codeguardBackupDownload = exports.useCodeguardBackupCreate = exports.codeguardBackupCreate = exports.useCodeguardBackupList = exports.getCodeguardBackupListQueryKey = exports.codeguardBackupList = void 0;
exports.useSshKeyList = exports.getSshKeyListQueryKey = exports.sshKeyList = exports.useSshKeyImport = exports.sshKeyImport = exports.useSshKeyFetch = exports.getSshKeyFetchQueryKey = exports.sshKeyFetch = exports.useHostingSshInfo = exports.getHostingSshInfoQueryKey = exports.hostingSshInfo = exports.useHostingSiteAdd = exports.hostingSiteAdd = exports.useHostingSites = exports.getHostingSitesQueryKey = exports.hostingSites = exports.useHostingShellInfo = exports.getHostingShellInfoQueryKey = exports.hostingShellInfo = exports.useHostingShellToggle = exports.hostingShellToggle = exports.useHostingNameservers = exports.getHostingNameserversQueryKey = exports.hostingNameservers = exports.useHostingMigrationSiteScanStatus = exports.getHostingMigrationSiteScanStatusQueryKey = exports.hostingMigrationSiteScanStatus = exports.useHostingMigrationInfo = exports.getHostingMigrationInfoQueryKey = exports.hostingMigrationInfo = exports.useHostingMigrationsEvent = exports.hostingMigrationsEvent = exports.useHostingMigrations = exports.hostingMigrations = exports.useHostingMigrationStatus = exports.getHostingMigrationStatusQueryKey = exports.hostingMigrationStatus = exports.useHostingInfoDiskUsage = exports.getHostingInfoDiskUsageQueryKey = exports.hostingInfoDiskUsage = exports.useHostingInfo = exports.getHostingInfoQueryKey = exports.hostingInfo = exports.useHostingFtpList = exports.getHostingFtpListQueryKey = exports.hostingFtpList = exports.useDomains = exports.getDomainsQueryKey = exports.domains = exports.useAddonCloudflare = void 0;
exports.useSitePluginsAutoupdate = exports.sitePluginsAutoupdate = exports.useSitePlugins = exports.getSitePluginsQueryKey = exports.sitePlugins = exports.useSitesPerformanceEndurancePageCache = exports.sitesPerformanceEndurancePageCache = exports.useSitesPerformanceEnduranceCacheLevel = exports.sitesPerformanceEnduranceCacheLevel = exports.useSitesPerformanceEnduranceCacheLevelStatus = exports.getSitesPerformanceEnduranceCacheLevelStatusQueryKey = exports.sitesPerformanceEnduranceCacheLevelStatus = exports.useSitesPerformanceCachepurge = exports.sitesPerformanceCachepurge = exports.useSitesDomainUrl = exports.sitesDomainUrl = exports.useSitesDomain = exports.getSitesDomainQueryKey = exports.sitesDomain = exports.useSitesDns = exports.getSitesDnsQueryKey = exports.sitesDns = exports.useJetpackBackupStatus = exports.getJetpackBackupStatusQueryKey = exports.jetpackBackupStatus = exports.useSitesBackups = exports.getSitesBackupsQueryKey = exports.sitesBackups = exports.useSitesAutoupdatesUpdate = exports.sitesAutoupdatesUpdate = exports.useSitesAutoupdatesInfo = exports.getSitesAutoupdatesInfoQueryKey = exports.sitesAutoupdatesInfo = exports.useSite = exports.site = exports.useSiteUpdate = exports.siteUpdate = exports.useSitesInfo = exports.getSitesInfoQueryKey = exports.sitesInfo = exports.useSitesList = exports.getSitesListQueryKey = exports.sitesList = exports.useSso = exports.getSsoQueryKey = exports.sso = exports.useSshKeyGenerate = exports.sshKeyGenerate = exports.useSshKey = exports.sshKey = void 0;
exports.sitesSso = exports.useSitesSettingsPhpVersions = exports.getSitesSettingsPhpVersionsQueryKey = exports.sitesSettingsPhpVersions = exports.useSitesSettingsPhpVersionUpdate = exports.sitesSettingsPhpVersionUpdate = exports.useSitesSettingsDebugToggle = exports.sitesSettingsDebugToggle = exports.useSitesSettingsDebug = exports.getSitesSettingsDebugQueryKey = exports.sitesSettingsDebug = exports.useSitesSettingsComingSoonToggle = exports.sitesSettingsComingSoonToggle = exports.useSitesSettingsComingSoon = exports.getSitesSettingsComingSoonQueryKey = exports.sitesSettingsComingSoon = exports.useSitesSettingsAutoupdatesTheme = exports.sitesSettingsAutoupdatesTheme = exports.useSitesSettingsAutoupdatesCore = exports.sitesSettingsAutoupdatesCore = exports.useSitesSettingsAutoupdates = exports.getSitesSettingsAutoupdatesQueryKey = exports.sitesSettingsAutoupdates = exports.useSiteSettingsAutoupdatePlugins = exports.getSiteSettingsAutoupdatePluginsQueryKey = exports.siteSettingsAutoupdatePlugins = exports.useSitesSecuritySslStatus = exports.getSitesSecuritySslStatusQueryKey = exports.sitesSecuritySslStatus = exports.useSitesSecuritySslAcme = exports.sitesSecuritySslAcme = exports.useSitesSecuritySitelock = exports.getSitesSecuritySitelockQueryKey = exports.sitesSecuritySitelock = exports.useSitesSecurityHttpsEnableDisableSsl = exports.sitesSecurityHttpsEnableDisableSsl = exports.useSitesSecurityHttpsRedirectionStatus = exports.getSitesSecurityHttpsRedirectionStatusQueryKey = exports.sitesSecurityHttpsRedirectionStatus = exports.useSitesSecurityResetCoreFiles = exports.sitesSecurityResetCoreFiles = exports.useSitesSecurityCheckCore = exports.getSitesSecurityCheckCoreQueryKey = exports.sitesSecurityCheckCore = exports.useResetSite = exports.resetSite = exports.useSitePluginsUpdate = exports.sitePluginsUpdate = exports.useSitePluginsToggle = exports.sitePluginsToggle = void 0;
exports.useSshKeyListV2 = exports.getSshKeyListV2QueryKey = exports.sshKeyListV2 = exports.useSitesVersion = exports.getSitesVersionQueryKey = exports.sitesVersion = exports.useSiteUsers = exports.getSiteUsersQueryKey = exports.siteUsers = exports.useSitesSso = exports.getSitesSsoQueryKey = void 0;
/**
 * Generated by orval v6.8.1 🍺
 * Do not edit manually.
 * Hosting UAPI
 * Hosting UAPI is an API to expose Hosting, Addons, and Site functionality to a customer-facing Front End such as (Account Manager).
 * OpenAPI spec version: 0.1.0-beta.296
 */
const axios = require("axios");
const react_query_1 = require("react-query");
/**
 * Returns a combined backup list with website commit ids and corresponding database commits
 * @summary backup list
 */
const codeguardBackupList = (addonId, params, options) => {
    return axios.default.get(`/v1/addons/codeguard/${addonId}/backups`, Object.assign({ params }, options));
};
exports.codeguardBackupList = codeguardBackupList;
const getCodeguardBackupListQueryKey = (addonId, params) => [`/v1/addons/codeguard/${addonId}/backups`, ...(params ? [params] : [])];
exports.getCodeguardBackupListQueryKey = getCodeguardBackupListQueryKey;
const useCodeguardBackupList = (addonId, params, options) => {
    var _a;
    const { query: queryOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_a = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _a !== void 0 ? _a : (0, exports.getCodeguardBackupListQueryKey)(addonId, params);
    const queryFn = ({ signal }) => (0, exports.codeguardBackupList)(addonId, params, Object.assign({ signal }, axiosOptions));
    const query = (0, react_query_1.useQuery)(queryKey, queryFn, Object.assign({ enabled: !!(addonId) }, queryOptions));
    return Object.assign({ queryKey }, query);
};
exports.useCodeguardBackupList = useCodeguardBackupList;
/**
 * Creates the website backup
 * @summary backup create
 */
const codeguardBackupCreate = (addonId, codeguardBackupCreateBody, options) => {
    return axios.default.post(`/v1/addons/codeguard/${addonId}/backups`, codeguardBackupCreateBody, options);
};
exports.codeguardBackupCreate = codeguardBackupCreate;
const useCodeguardBackupCreate = (options) => {
    const { mutation: mutationOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const mutationFn = (props) => {
        const { addonId, data } = props !== null && props !== void 0 ? props : {};
        return (0, exports.codeguardBackupCreate)(addonId, data, axiosOptions);
    };
    return (0, react_query_1.useMutation)(mutationFn, mutationOptions);
};
exports.useCodeguardBackupCreate = useCodeguardBackupCreate;
/**
 * Queues the backup download.
 * @summary backup download
 */
const codeguardBackupDownload = (addonId, codeguardBackupDownloadBody, options) => {
    return axios.default.post(`/v1/addons/codeguard/${addonId}/backups/download`, codeguardBackupDownloadBody, options);
};
exports.codeguardBackupDownload = codeguardBackupDownload;
const useCodeguardBackupDownload = (options) => {
    const { mutation: mutationOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const mutationFn = (props) => {
        const { addonId, data } = props !== null && props !== void 0 ? props : {};
        return (0, exports.codeguardBackupDownload)(addonId, data, axiosOptions);
    };
    return (0, react_query_1.useMutation)(mutationFn, mutationOptions);
};
exports.useCodeguardBackupDownload = useCodeguardBackupDownload;
/**
 * Restores a website and database backup
 * @summary backups restore
 */
const codeguardBackupRestore = (addonId, codeguardBackupRestoreBody, options) => {
    return axios.default.post(`/v1/addons/codeguard/${addonId}/backups/restore`, codeguardBackupRestoreBody, options);
};
exports.codeguardBackupRestore = codeguardBackupRestore;
const useCodeguardBackupRestore = (options) => {
    const { mutation: mutationOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const mutationFn = (props) => {
        const { addonId, data } = props !== null && props !== void 0 ? props : {};
        return (0, exports.codeguardBackupRestore)(addonId, data, axiosOptions);
    };
    return (0, react_query_1.useMutation)(mutationFn, mutationOptions);
};
exports.useCodeguardBackupRestore = useCodeguardBackupRestore;
/**
 * Returns all database records CodeGuard maintains for this user's account.
 * @summary database list
 */
const codeguardDatabaseList = (addonId, options) => {
    return axios.default.get(`/v1/addons/codeguard/${addonId}/databases`, options);
};
exports.codeguardDatabaseList = codeguardDatabaseList;
const getCodeguardDatabaseListQueryKey = (addonId) => [`/v1/addons/codeguard/${addonId}/databases`];
exports.getCodeguardDatabaseListQueryKey = getCodeguardDatabaseListQueryKey;
const useCodeguardDatabaseList = (addonId, options) => {
    var _a;
    const { query: queryOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_a = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _a !== void 0 ? _a : (0, exports.getCodeguardDatabaseListQueryKey)(addonId);
    const queryFn = ({ signal }) => (0, exports.codeguardDatabaseList)(addonId, Object.assign({ signal }, axiosOptions));
    const query = (0, react_query_1.useQuery)(queryKey, queryFn, Object.assign({ enabled: !!(addonId) }, queryOptions));
    return Object.assign({ queryKey }, query);
};
exports.useCodeguardDatabaseList = useCodeguardDatabaseList;
/**
 * Returns all database backup records CodeGuard maintains for this user's account.
 * @summary database backup list
 */
const codeguardDatabaseBackupList = (addonId, params, options) => {
    return axios.default.get(`/v1/addons/codeguard/${addonId}/databases/backups`, Object.assign({ params }, options));
};
exports.codeguardDatabaseBackupList = codeguardDatabaseBackupList;
const getCodeguardDatabaseBackupListQueryKey = (addonId, params) => [`/v1/addons/codeguard/${addonId}/databases/backups`, ...(params ? [params] : [])];
exports.getCodeguardDatabaseBackupListQueryKey = getCodeguardDatabaseBackupListQueryKey;
const useCodeguardDatabaseBackupList = (addonId, params, options) => {
    var _a;
    const { query: queryOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_a = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _a !== void 0 ? _a : (0, exports.getCodeguardDatabaseBackupListQueryKey)(addonId, params);
    const queryFn = ({ signal }) => (0, exports.codeguardDatabaseBackupList)(addonId, params, Object.assign({ signal }, axiosOptions));
    const query = (0, react_query_1.useQuery)(queryKey, queryFn, Object.assign({ enabled: !!(addonId) }, queryOptions));
    return Object.assign({ queryKey }, query);
};
exports.useCodeguardDatabaseBackupList = useCodeguardDatabaseBackupList;
/**
 * Queue the creation of a database backup.
 * @summary database backup create
 */
const codeguardDatabaseBackupCreate = (addonId, codeguardDatabaseBackupCreateBody, options) => {
    return axios.default.post(`/v1/addons/codeguard/${addonId}/databases/backups`, codeguardDatabaseBackupCreateBody, options);
};
exports.codeguardDatabaseBackupCreate = codeguardDatabaseBackupCreate;
const useCodeguardDatabaseBackupCreate = (options) => {
    const { mutation: mutationOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const mutationFn = (props) => {
        const { addonId, data } = props !== null && props !== void 0 ? props : {};
        return (0, exports.codeguardDatabaseBackupCreate)(addonId, data, axiosOptions);
    };
    return (0, react_query_1.useMutation)(mutationFn, mutationOptions);
};
exports.useCodeguardDatabaseBackupCreate = useCodeguardDatabaseBackupCreate;
/**
 * Restores a database backup
 * @summary  database backup restore
 */
const codeguardDatabaseBackupRestore = (addonId, codeguardDatabaseBackupRestoreBody, options) => {
    return axios.default.post(`/v1/addons/codeguard/${addonId}/databases/backups/restore`, codeguardDatabaseBackupRestoreBody, options);
};
exports.codeguardDatabaseBackupRestore = codeguardDatabaseBackupRestore;
const useCodeguardDatabaseBackupRestore = (options) => {
    const { mutation: mutationOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const mutationFn = (props) => {
        const { addonId, data } = props !== null && props !== void 0 ? props : {};
        return (0, exports.codeguardDatabaseBackupRestore)(addonId, data, axiosOptions);
    };
    return (0, react_query_1.useMutation)(mutationFn, mutationOptions);
};
exports.useCodeguardDatabaseBackupRestore = useCodeguardDatabaseBackupRestore;
/**
 * Returns an oauth login URL that can be used to access CodeGuard dashboard for a user.
 * @summary login link
 */
const codeguardLoginLink = (addonId, options) => {
    return axios.default.get(`/v1/addons/codeguard/${addonId}/login`, options);
};
exports.codeguardLoginLink = codeguardLoginLink;
const getCodeguardLoginLinkQueryKey = (addonId) => [`/v1/addons/codeguard/${addonId}/login`];
exports.getCodeguardLoginLinkQueryKey = getCodeguardLoginLinkQueryKey;
const useCodeguardLoginLink = (addonId, options) => {
    var _a;
    const { query: queryOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_a = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _a !== void 0 ? _a : (0, exports.getCodeguardLoginLinkQueryKey)(addonId);
    const queryFn = ({ signal }) => (0, exports.codeguardLoginLink)(addonId, Object.assign({ signal }, axiosOptions));
    const query = (0, react_query_1.useQuery)(queryKey, queryFn, Object.assign({ enabled: !!(addonId) }, queryOptions));
    return Object.assign({ queryKey }, query);
};
exports.useCodeguardLoginLink = useCodeguardLoginLink;
/**
 * Returns the subscribed plan and usage info
 * @summary plan info
 */
const codeguardPlanInfo = (addonId, options) => {
    return axios.default.get(`/v1/addons/codeguard/${addonId}/plan`, options);
};
exports.codeguardPlanInfo = codeguardPlanInfo;
const getCodeguardPlanInfoQueryKey = (addonId) => [`/v1/addons/codeguard/${addonId}/plan`];
exports.getCodeguardPlanInfoQueryKey = getCodeguardPlanInfoQueryKey;
const useCodeguardPlanInfo = (addonId, options) => {
    var _a;
    const { query: queryOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_a = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _a !== void 0 ? _a : (0, exports.getCodeguardPlanInfoQueryKey)(addonId);
    const queryFn = ({ signal }) => (0, exports.codeguardPlanInfo)(addonId, Object.assign({ signal }, axiosOptions));
    const query = (0, react_query_1.useQuery)(queryKey, queryFn, Object.assign({ enabled: !!(addonId) }, queryOptions));
    return Object.assign({ queryKey }, query);
};
exports.useCodeguardPlanInfo = useCodeguardPlanInfo;
/**
 * Returns all website records CodeGuard maintains for this user's account.
 * @summary website list
 */
const codeguardWebsiteList = (addonId, options) => {
    return axios.default.get(`/v1/addons/codeguard/${addonId}/websites`, options);
};
exports.codeguardWebsiteList = codeguardWebsiteList;
const getCodeguardWebsiteListQueryKey = (addonId) => [`/v1/addons/codeguard/${addonId}/websites`];
exports.getCodeguardWebsiteListQueryKey = getCodeguardWebsiteListQueryKey;
const useCodeguardWebsiteList = (addonId, options) => {
    var _a;
    const { query: queryOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_a = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _a !== void 0 ? _a : (0, exports.getCodeguardWebsiteListQueryKey)(addonId);
    const queryFn = ({ signal }) => (0, exports.codeguardWebsiteList)(addonId, Object.assign({ signal }, axiosOptions));
    const query = (0, react_query_1.useQuery)(queryKey, queryFn, Object.assign({ enabled: !!(addonId) }, queryOptions));
    return Object.assign({ queryKey }, query);
};
exports.useCodeguardWebsiteList = useCodeguardWebsiteList;
/**
 * Returns all website backup records CodeGuard maintains for this user's account.
 * @summary  website backup list
 */
const codeguardWebsiteBackupList = (addonId, params, options) => {
    return axios.default.get(`/v1/addons/codeguard/${addonId}/websites/backups`, Object.assign({ params }, options));
};
exports.codeguardWebsiteBackupList = codeguardWebsiteBackupList;
const getCodeguardWebsiteBackupListQueryKey = (addonId, params) => [`/v1/addons/codeguard/${addonId}/websites/backups`, ...(params ? [params] : [])];
exports.getCodeguardWebsiteBackupListQueryKey = getCodeguardWebsiteBackupListQueryKey;
const useCodeguardWebsiteBackupList = (addonId, params, options) => {
    var _a;
    const { query: queryOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_a = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _a !== void 0 ? _a : (0, exports.getCodeguardWebsiteBackupListQueryKey)(addonId, params);
    const queryFn = ({ signal }) => (0, exports.codeguardWebsiteBackupList)(addonId, params, Object.assign({ signal }, axiosOptions));
    const query = (0, react_query_1.useQuery)(queryKey, queryFn, Object.assign({ enabled: !!(addonId) }, queryOptions));
    return Object.assign({ queryKey }, query);
};
exports.useCodeguardWebsiteBackupList = useCodeguardWebsiteBackupList;
/**
 * Initiate the creation of a new backup for a given website
 * @summary website backup create
 */
const codeguardWebsiteBackupCreate = (addonId, codeguardWebsiteBackupCreateBody, options) => {
    return axios.default.post(`/v1/addons/codeguard/${addonId}/websites/backups`, codeguardWebsiteBackupCreateBody, options);
};
exports.codeguardWebsiteBackupCreate = codeguardWebsiteBackupCreate;
const useCodeguardWebsiteBackupCreate = (options) => {
    const { mutation: mutationOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const mutationFn = (props) => {
        const { addonId, data } = props !== null && props !== void 0 ? props : {};
        return (0, exports.codeguardWebsiteBackupCreate)(addonId, data, axiosOptions);
    };
    return (0, react_query_1.useMutation)(mutationFn, mutationOptions);
};
exports.useCodeguardWebsiteBackupCreate = useCodeguardWebsiteBackupCreate;
/**
 * Restores a website backup
 * @summary  website backup restore
 */
const codeguardWebsiteBackupRestore = (addonId, codeguardWebsiteBackupRestoreBody, options) => {
    return axios.default.post(`/v1/addons/codeguard/${addonId}/websites/backups/restore`, codeguardWebsiteBackupRestoreBody, options);
};
exports.codeguardWebsiteBackupRestore = codeguardWebsiteBackupRestore;
const useCodeguardWebsiteBackupRestore = (options) => {
    const { mutation: mutationOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const mutationFn = (props) => {
        const { addonId, data } = props !== null && props !== void 0 ? props : {};
        return (0, exports.codeguardWebsiteBackupRestore)(addonId, data, axiosOptions);
    };
    return (0, react_query_1.useMutation)(mutationFn, mutationOptions);
};
exports.useCodeguardWebsiteBackupRestore = useCodeguardWebsiteBackupRestore;
/**
 * Returns an oauth login URL that can be used to access Sitelock dashboard for a user.
 * @summary sso
 */
const addonsSitelockSso = (addonId, options) => {
    return axios.default.get(`/v1/addons/sitelock/${addonId}/sso`, options);
};
exports.addonsSitelockSso = addonsSitelockSso;
const getAddonsSitelockSsoQueryKey = (addonId) => [`/v1/addons/sitelock/${addonId}/sso`];
exports.getAddonsSitelockSsoQueryKey = getAddonsSitelockSsoQueryKey;
const useAddonsSitelockSso = (addonId, options) => {
    var _a;
    const { query: queryOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_a = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _a !== void 0 ? _a : (0, exports.getAddonsSitelockSsoQueryKey)(addonId);
    const queryFn = ({ signal }) => (0, exports.addonsSitelockSso)(addonId, Object.assign({ signal }, axiosOptions));
    const query = (0, react_query_1.useQuery)(queryKey, queryFn, Object.assign({ enabled: !!(addonId) }, queryOptions));
    return Object.assign({ queryKey }, query);
};
exports.useAddonsSitelockSso = useAddonsSitelockSso;
/**
 * Decom and delete cloudflare basic addon
 * @summary Uninstall cloudflare basic addon
 */
const addonsCloudflare = (addonId, options) => {
    return axios.default.delete(`/v1/addons/${addonId}/cloudflare`, options);
};
exports.addonsCloudflare = addonsCloudflare;
const useAddonsCloudflare = (options) => {
    const { mutation: mutationOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const mutationFn = (props) => {
        const { addonId } = props !== null && props !== void 0 ? props : {};
        return (0, exports.addonsCloudflare)(addonId, axiosOptions);
    };
    return (0, react_query_1.useMutation)(mutationFn, mutationOptions);
};
exports.useAddonsCloudflare = useAddonsCloudflare;
/**
 * Returns addon information
 * @summary info
 */
const addonsInfo = (addonId, options) => {
    return axios.default.get(`/v1/addons/${addonId}/info`, options);
};
exports.addonsInfo = addonsInfo;
const getAddonsInfoQueryKey = (addonId) => [`/v1/addons/${addonId}/info`];
exports.getAddonsInfoQueryKey = getAddonsInfoQueryKey;
const useAddonsInfo = (addonId, options) => {
    var _a;
    const { query: queryOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_a = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _a !== void 0 ? _a : (0, exports.getAddonsInfoQueryKey)(addonId);
    const queryFn = ({ signal }) => (0, exports.addonsInfo)(addonId, Object.assign({ signal }, axiosOptions));
    const query = (0, react_query_1.useQuery)(queryKey, queryFn, Object.assign({ enabled: !!(addonId) }, queryOptions));
    return Object.assign({ queryKey }, query);
};
exports.useAddonsInfo = useAddonsInfo;
/**
 * Returns a list of addons.
 * @summary addon list
 */
const hostingAddons = (hostingId, params, options) => {
    return axios.default.get(`/v1/hosting/${hostingId}/addons`, Object.assign({ params }, options));
};
exports.hostingAddons = hostingAddons;
const getHostingAddonsQueryKey = (hostingId, params) => [`/v1/hosting/${hostingId}/addons`, ...(params ? [params] : [])];
exports.getHostingAddonsQueryKey = getHostingAddonsQueryKey;
const useHostingAddons = (hostingId, params, options) => {
    var _a;
    const { query: queryOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_a = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _a !== void 0 ? _a : (0, exports.getHostingAddonsQueryKey)(hostingId, params);
    const queryFn = ({ signal }) => (0, exports.hostingAddons)(hostingId, params, Object.assign({ signal }, axiosOptions));
    const query = (0, react_query_1.useQuery)(queryKey, queryFn, Object.assign({ enabled: !!(hostingId) }, queryOptions));
    return Object.assign({ queryKey }, query);
};
exports.useHostingAddons = useHostingAddons;
/**
 * Returns the hosting server info
 * @summary server status/info
 */
const hostingAdvancedServer = (hostingId, options) => {
    return axios.default.get(`/v1/hosting/${hostingId}/advanced/server`, options);
};
exports.hostingAdvancedServer = hostingAdvancedServer;
const getHostingAdvancedServerQueryKey = (hostingId) => [`/v1/hosting/${hostingId}/advanced/server`];
exports.getHostingAdvancedServerQueryKey = getHostingAdvancedServerQueryKey;
const useHostingAdvancedServer = (hostingId, options) => {
    var _a;
    const { query: queryOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_a = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _a !== void 0 ? _a : (0, exports.getHostingAdvancedServerQueryKey)(hostingId);
    const queryFn = ({ signal }) => (0, exports.hostingAdvancedServer)(hostingId, Object.assign({ signal }, axiosOptions));
    const query = (0, react_query_1.useQuery)(queryKey, queryFn, Object.assign({ enabled: !!(hostingId) }, queryOptions));
    return Object.assign({ queryKey }, query);
};
exports.useHostingAdvancedServer = useHostingAdvancedServer;
/**
 * Creates cloudflare basic addon
 * @summary Install cloudflare basic addon
 */
const addonCloudflare = (hostingId, addonCloudflareBody, options) => {
    return axios.default.post(`/v1/hosting/${hostingId}/cloudflare`, addonCloudflareBody, options);
};
exports.addonCloudflare = addonCloudflare;
const useAddonCloudflare = (options) => {
    const { mutation: mutationOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const mutationFn = (props) => {
        const { hostingId, data } = props !== null && props !== void 0 ? props : {};
        return (0, exports.addonCloudflare)(hostingId, data, axiosOptions);
    };
    return (0, react_query_1.useMutation)(mutationFn, mutationOptions);
};
exports.useAddonCloudflare = useAddonCloudflare;
/**
 * Returns a list of domains
 * @summary domain list
 */
const domains = (hostingId, params, options) => {
    return axios.default.get(`/v1/hosting/${hostingId}/domains`, Object.assign({ params }, options));
};
exports.domains = domains;
const getDomainsQueryKey = (hostingId, params) => [`/v1/hosting/${hostingId}/domains`, ...(params ? [params] : [])];
exports.getDomainsQueryKey = getDomainsQueryKey;
const useDomains = (hostingId, params, options) => {
    var _a;
    const { query: queryOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_a = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _a !== void 0 ? _a : (0, exports.getDomainsQueryKey)(hostingId, params);
    const queryFn = ({ signal }) => (0, exports.domains)(hostingId, params, Object.assign({ signal }, axiosOptions));
    const query = (0, react_query_1.useQuery)(queryKey, queryFn, Object.assign({ enabled: !!(hostingId) }, queryOptions));
    return Object.assign({ queryKey }, query);
};
exports.useDomains = useDomains;
/**
 * Returns a list of FTP accounts.
 * @summary ftp list
 */
const hostingFtpList = (hostingId, options) => {
    return axios.default.get(`/v1/hosting/${hostingId}/ftp`, options);
};
exports.hostingFtpList = hostingFtpList;
const getHostingFtpListQueryKey = (hostingId) => [`/v1/hosting/${hostingId}/ftp`];
exports.getHostingFtpListQueryKey = getHostingFtpListQueryKey;
const useHostingFtpList = (hostingId, options) => {
    var _a;
    const { query: queryOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_a = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _a !== void 0 ? _a : (0, exports.getHostingFtpListQueryKey)(hostingId);
    const queryFn = ({ signal }) => (0, exports.hostingFtpList)(hostingId, Object.assign({ signal }, axiosOptions));
    const query = (0, react_query_1.useQuery)(queryKey, queryFn, Object.assign({ enabled: !!(hostingId) }, queryOptions));
    return Object.assign({ queryKey }, query);
};
exports.useHostingFtpList = useHostingFtpList;
/**
 * Returns hosting account info
 * @summary Hosting info
 */
const hostingInfo = (hostingId, options) => {
    return axios.default.get(`/v1/hosting/${hostingId}/info`, options);
};
exports.hostingInfo = hostingInfo;
const getHostingInfoQueryKey = (hostingId) => [`/v1/hosting/${hostingId}/info`];
exports.getHostingInfoQueryKey = getHostingInfoQueryKey;
const useHostingInfo = (hostingId, options) => {
    var _a;
    const { query: queryOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_a = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _a !== void 0 ? _a : (0, exports.getHostingInfoQueryKey)(hostingId);
    const queryFn = ({ signal }) => (0, exports.hostingInfo)(hostingId, Object.assign({ signal }, axiosOptions));
    const query = (0, react_query_1.useQuery)(queryKey, queryFn, Object.assign({ enabled: !!(hostingId) }, queryOptions));
    return Object.assign({ queryKey }, query);
};
exports.useHostingInfo = useHostingInfo;
/**
 * Returns the hosting account's disk usage
 * @summary info disk usage
 */
const hostingInfoDiskUsage = (hostingId, options) => {
    return axios.default.get(`/v1/hosting/${hostingId}/info/diskusage`, options);
};
exports.hostingInfoDiskUsage = hostingInfoDiskUsage;
const getHostingInfoDiskUsageQueryKey = (hostingId) => [`/v1/hosting/${hostingId}/info/diskusage`];
exports.getHostingInfoDiskUsageQueryKey = getHostingInfoDiskUsageQueryKey;
const useHostingInfoDiskUsage = (hostingId, options) => {
    var _a;
    const { query: queryOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_a = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _a !== void 0 ? _a : (0, exports.getHostingInfoDiskUsageQueryKey)(hostingId);
    const queryFn = ({ signal }) => (0, exports.hostingInfoDiskUsage)(hostingId, Object.assign({ signal }, axiosOptions));
    const query = (0, react_query_1.useQuery)(queryKey, queryFn, Object.assign({ enabled: !!(hostingId) }, queryOptions));
    return Object.assign({ queryKey }, query);
};
exports.useHostingInfoDiskUsage = useHostingInfoDiskUsage;
/**
 * Gets the Wordpress migration status
 * @summary Wordpress migration status
 */
const hostingMigrationStatus = (hostingId, options) => {
    return axios.default.get(`/v1/hosting/${hostingId}/migrations`, options);
};
exports.hostingMigrationStatus = hostingMigrationStatus;
const getHostingMigrationStatusQueryKey = (hostingId) => [`/v1/hosting/${hostingId}/migrations`];
exports.getHostingMigrationStatusQueryKey = getHostingMigrationStatusQueryKey;
const useHostingMigrationStatus = (hostingId, options) => {
    var _a;
    const { query: queryOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_a = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _a !== void 0 ? _a : (0, exports.getHostingMigrationStatusQueryKey)(hostingId);
    const queryFn = ({ signal }) => (0, exports.hostingMigrationStatus)(hostingId, Object.assign({ signal }, axiosOptions));
    const query = (0, react_query_1.useQuery)(queryKey, queryFn, Object.assign({ enabled: !!(hostingId) }, queryOptions));
    return Object.assign({ queryKey }, query);
};
exports.useHostingMigrationStatus = useHostingMigrationStatus;
/**
 * Adds the wordpressmigrate addon for a given migration id and hosting account
 * @summary start the migration process for a site
 */
const hostingMigrations = (hostingId, hostingMigrationsBody, options) => {
    return axios.default.post(`/v1/hosting/${hostingId}/migrations`, hostingMigrationsBody, options);
};
exports.hostingMigrations = hostingMigrations;
const useHostingMigrations = (options) => {
    const { mutation: mutationOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const mutationFn = (props) => {
        const { hostingId, data } = props !== null && props !== void 0 ? props : {};
        return (0, exports.hostingMigrations)(hostingId, data, axiosOptions);
    };
    return (0, react_query_1.useMutation)(mutationFn, mutationOptions);
};
exports.useHostingMigrations = useHostingMigrations;
/**
 * Post migration event to CWM
 * @summary hosting migrations event
 */
const hostingMigrationsEvent = (hostingId, hostingMigrationsEventBody, options) => {
    return axios.default.post(`/v1/hosting/${hostingId}/migrations/event`, hostingMigrationsEventBody, options);
};
exports.hostingMigrationsEvent = hostingMigrationsEvent;
const useHostingMigrationsEvent = (options) => {
    const { mutation: mutationOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const mutationFn = (props) => {
        const { hostingId, data } = props !== null && props !== void 0 ? props : {};
        return (0, exports.hostingMigrationsEvent)(hostingId, data, axiosOptions);
    };
    return (0, react_query_1.useMutation)(mutationFn, mutationOptions);
};
exports.useHostingMigrationsEvent = useHostingMigrationsEvent;
/**
 * Gets the Wordpress migration information
 * @summary Wordpress migration information
 */
const hostingMigrationInfo = (hostingId, params, options) => {
    return axios.default.get(`/v1/hosting/${hostingId}/migrations/info`, Object.assign({ params }, options));
};
exports.hostingMigrationInfo = hostingMigrationInfo;
const getHostingMigrationInfoQueryKey = (hostingId, params) => [`/v1/hosting/${hostingId}/migrations/info`, ...(params ? [params] : [])];
exports.getHostingMigrationInfoQueryKey = getHostingMigrationInfoQueryKey;
const useHostingMigrationInfo = (hostingId, params, options) => {
    var _a;
    const { query: queryOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_a = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _a !== void 0 ? _a : (0, exports.getHostingMigrationInfoQueryKey)(hostingId, params);
    const queryFn = ({ signal }) => (0, exports.hostingMigrationInfo)(hostingId, params, Object.assign({ signal }, axiosOptions));
    const query = (0, react_query_1.useQuery)(queryKey, queryFn, Object.assign({ enabled: !!(hostingId) }, queryOptions));
    return Object.assign({ queryKey }, query);
};
exports.useHostingMigrationInfo = useHostingMigrationInfo;
/**
 * Provides the status of SiteMigration site_scan and deeplink to WordPress admin page
 * @summary SiteMigration site_scan status
 */
const hostingMigrationSiteScanStatus = (hostingId, params, options) => {
    return axios.default.get(`/v1/hosting/${hostingId}/migrations/site-scan`, Object.assign({ params }, options));
};
exports.hostingMigrationSiteScanStatus = hostingMigrationSiteScanStatus;
const getHostingMigrationSiteScanStatusQueryKey = (hostingId, params) => [`/v1/hosting/${hostingId}/migrations/site-scan`, ...(params ? [params] : [])];
exports.getHostingMigrationSiteScanStatusQueryKey = getHostingMigrationSiteScanStatusQueryKey;
const useHostingMigrationSiteScanStatus = (hostingId, params, options) => {
    var _a;
    const { query: queryOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_a = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _a !== void 0 ? _a : (0, exports.getHostingMigrationSiteScanStatusQueryKey)(hostingId, params);
    const queryFn = ({ signal }) => (0, exports.hostingMigrationSiteScanStatus)(hostingId, params, Object.assign({ signal }, axiosOptions));
    const query = (0, react_query_1.useQuery)(queryKey, queryFn, Object.assign({ enabled: !!(hostingId) }, queryOptions));
    return Object.assign({ queryKey }, query);
};
exports.useHostingMigrationSiteScanStatus = useHostingMigrationSiteScanStatus;
/**
 * Returns the hosting brand nameservers
 * @summary hosting nameservers
 */
const hostingNameservers = (hostingId, options) => {
    return axios.default.get(`/v1/hosting/${hostingId}/nameservers`, options);
};
exports.hostingNameservers = hostingNameservers;
const getHostingNameserversQueryKey = (hostingId) => [`/v1/hosting/${hostingId}/nameservers`];
exports.getHostingNameserversQueryKey = getHostingNameserversQueryKey;
const useHostingNameservers = (hostingId, options) => {
    var _a;
    const { query: queryOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_a = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _a !== void 0 ? _a : (0, exports.getHostingNameserversQueryKey)(hostingId);
    const queryFn = ({ signal }) => (0, exports.hostingNameservers)(hostingId, Object.assign({ signal }, axiosOptions));
    const query = (0, react_query_1.useQuery)(queryKey, queryFn, Object.assign({ enabled: !!(hostingId) }, queryOptions));
    return Object.assign({ queryKey }, query);
};
exports.useHostingNameservers = useHostingNameservers;
/**
 * Enable or disable shell access on an account by setting the shell.SSH key access must be established separately.
 * @summary hosting shell toggle
 */
const hostingShellToggle = (hostingId, hostingShellToggleBody, options) => {
    return axios.default.put(`/v1/hosting/${hostingId}/shell`, hostingShellToggleBody, options);
};
exports.hostingShellToggle = hostingShellToggle;
const useHostingShellToggle = (options) => {
    const { mutation: mutationOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const mutationFn = (props) => {
        const { hostingId, data } = props !== null && props !== void 0 ? props : {};
        return (0, exports.hostingShellToggle)(hostingId, data, axiosOptions);
    };
    return (0, react_query_1.useMutation)(mutationFn, mutationOptions);
};
exports.useHostingShellToggle = useHostingShellToggle;
/**
 * Determine shell access status for an account.
 * @summary hosting shell_status
 */
const hostingShellInfo = (hostingId, options) => {
    return axios.default.get(`/v1/hosting/${hostingId}/shell`, options);
};
exports.hostingShellInfo = hostingShellInfo;
const getHostingShellInfoQueryKey = (hostingId) => [`/v1/hosting/${hostingId}/shell`];
exports.getHostingShellInfoQueryKey = getHostingShellInfoQueryKey;
const useHostingShellInfo = (hostingId, options) => {
    var _a;
    const { query: queryOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_a = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _a !== void 0 ? _a : (0, exports.getHostingShellInfoQueryKey)(hostingId);
    const queryFn = ({ signal }) => (0, exports.hostingShellInfo)(hostingId, Object.assign({ signal }, axiosOptions));
    const query = (0, react_query_1.useQuery)(queryKey, queryFn, Object.assign({ enabled: !!(hostingId) }, queryOptions));
    return Object.assign({ queryKey }, query);
};
exports.useHostingShellInfo = useHostingShellInfo;
/**
 * Returns a list of sites.
 * @summary sites list
 */
const hostingSites = (hostingId, options) => {
    return axios.default.get(`/v1/hosting/${hostingId}/sites`, options);
};
exports.hostingSites = hostingSites;
const getHostingSitesQueryKey = (hostingId) => [`/v1/hosting/${hostingId}/sites`];
exports.getHostingSitesQueryKey = getHostingSitesQueryKey;
const useHostingSites = (hostingId, options) => {
    var _a;
    const { query: queryOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_a = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _a !== void 0 ? _a : (0, exports.getHostingSitesQueryKey)(hostingId);
    const queryFn = ({ signal }) => (0, exports.hostingSites)(hostingId, Object.assign({ signal }, axiosOptions));
    const query = (0, react_query_1.useQuery)(queryKey, queryFn, Object.assign({ enabled: !!(hostingId) }, queryOptions));
    return Object.assign({ queryKey }, query);
};
exports.useHostingSites = useHostingSites;
/**
 * Add a site to the current hosting.
 * @summary sites add
 */
const hostingSiteAdd = (hostingId, hostingSiteAddBody, options) => {
    return axios.default.post(`/v1/hosting/${hostingId}/sites`, hostingSiteAddBody, options);
};
exports.hostingSiteAdd = hostingSiteAdd;
const useHostingSiteAdd = (options) => {
    const { mutation: mutationOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const mutationFn = (props) => {
        const { hostingId, data } = props !== null && props !== void 0 ? props : {};
        return (0, exports.hostingSiteAdd)(hostingId, data, axiosOptions);
    };
    return (0, react_query_1.useMutation)(mutationFn, mutationOptions);
};
exports.useHostingSiteAdd = useHostingSiteAdd;
/**
 * Returns the hosting account's SSH information
 * @summary ssh info
 */
const hostingSshInfo = (hostingId, options) => {
    return axios.default.get(`/v1/hosting/${hostingId}/ssh`, options);
};
exports.hostingSshInfo = hostingSshInfo;
const getHostingSshInfoQueryKey = (hostingId) => [`/v1/hosting/${hostingId}/ssh`];
exports.getHostingSshInfoQueryKey = getHostingSshInfoQueryKey;
const useHostingSshInfo = (hostingId, options) => {
    var _a;
    const { query: queryOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_a = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _a !== void 0 ? _a : (0, exports.getHostingSshInfoQueryKey)(hostingId);
    const queryFn = ({ signal }) => (0, exports.hostingSshInfo)(hostingId, Object.assign({ signal }, axiosOptions));
    const query = (0, react_query_1.useQuery)(queryKey, queryFn, Object.assign({ enabled: !!(hostingId) }, queryOptions));
    return Object.assign({ queryKey }, query);
};
exports.useHostingSshInfo = useHostingSshInfo;
/**
 * Fetches an SSH public (or optionally private) key.
 * @summary ssh key fetch
 */
const sshKeyFetch = (hostingId, params, options) => {
    return axios.default.get(`/v1/hosting/${hostingId}/ssh/fetch`, Object.assign({ params }, options));
};
exports.sshKeyFetch = sshKeyFetch;
const getSshKeyFetchQueryKey = (hostingId, params) => [`/v1/hosting/${hostingId}/ssh/fetch`, ...(params ? [params] : [])];
exports.getSshKeyFetchQueryKey = getSshKeyFetchQueryKey;
const useSshKeyFetch = (hostingId, params, options) => {
    var _a;
    const { query: queryOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_a = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _a !== void 0 ? _a : (0, exports.getSshKeyFetchQueryKey)(hostingId, params);
    const queryFn = ({ signal }) => (0, exports.sshKeyFetch)(hostingId, params, Object.assign({ signal }, axiosOptions));
    const query = (0, react_query_1.useQuery)(queryKey, queryFn, Object.assign({ enabled: !!(hostingId) }, queryOptions));
    return Object.assign({ queryKey }, query);
};
exports.useSshKeyFetch = useSshKeyFetch;
/**
 * Import public/private ssh key
 * @summary Import ssh key
 */
const sshKeyImport = (hostingId, sshKeyImportBody, options) => {
    return axios.default.post(`/v1/hosting/${hostingId}/ssh/import`, sshKeyImportBody, options);
};
exports.sshKeyImport = sshKeyImport;
const useSshKeyImport = (options) => {
    const { mutation: mutationOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const mutationFn = (props) => {
        const { hostingId, data } = props !== null && props !== void 0 ? props : {};
        return (0, exports.sshKeyImport)(hostingId, data, axiosOptions);
    };
    return (0, react_query_1.useMutation)(mutationFn, mutationOptions);
};
exports.useSshKeyImport = useSshKeyImport;
/**
 * List all SSH keys on a server or account. Finds all keys in user's .ssh/ diretory.
 * @deprecated
 * @summary Deprecated - ssh keys list
 */
const sshKeyList = (hostingId, options) => {
    return axios.default.get(`/v1/hosting/${hostingId}/ssh/keys`, options);
};
exports.sshKeyList = sshKeyList;
const getSshKeyListQueryKey = (hostingId) => [`/v1/hosting/${hostingId}/ssh/keys`];
exports.getSshKeyListQueryKey = getSshKeyListQueryKey;
const useSshKeyList = (hostingId, options) => {
    var _a;
    const { query: queryOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_a = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _a !== void 0 ? _a : (0, exports.getSshKeyListQueryKey)(hostingId);
    const queryFn = ({ signal }) => (0, exports.sshKeyList)(hostingId, Object.assign({ signal }, axiosOptions));
    const query = (0, react_query_1.useQuery)(queryKey, queryFn, Object.assign({ enabled: !!(hostingId) }, queryOptions));
    return Object.assign({ queryKey }, query);
};
exports.useSshKeyList = useSshKeyList;
/**
 * Deletes an SSH key
 * @summary ssh key delete
 */
const sshKey = (hostingId, sshKeyBody, options) => {
    return axios.default.delete(`/v1/hosting/${hostingId}/ssh/keys`, Object.assign({ data: sshKeyBody }, options));
};
exports.sshKey = sshKey;
const useSshKey = (options) => {
    const { mutation: mutationOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const mutationFn = (props) => {
        const { hostingId, data } = props !== null && props !== void 0 ? props : {};
        return (0, exports.sshKey)(hostingId, data, axiosOptions);
    };
    return (0, react_query_1.useMutation)(mutationFn, mutationOptions);
};
exports.useSshKey = useSshKey;
/**
 * Generates public/private ssh keys
 * @summary Generate ssh key
 */
const sshKeyGenerate = (hostingId, sshKeyGenerateBody, options) => {
    return axios.default.post(`/v1/hosting/${hostingId}/ssh/keys`, sshKeyGenerateBody, options);
};
exports.sshKeyGenerate = sshKeyGenerate;
const useSshKeyGenerate = (options) => {
    const { mutation: mutationOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const mutationFn = (props) => {
        const { hostingId, data } = props !== null && props !== void 0 ? props : {};
        return (0, exports.sshKeyGenerate)(hostingId, data, axiosOptions);
    };
    return (0, react_query_1.useMutation)(mutationFn, mutationOptions);
};
exports.useSshKeyGenerate = useSshKeyGenerate;
/**
 * Returns a SSO login token for a hosting account by default, or directly to various apps within the hosting account by using the optional query parameter.
 * @summary sso
 */
const sso = (hostingId, params, options) => {
    return axios.default.get(`/v1/hosting/${hostingId}/sso`, Object.assign({ params }, options));
};
exports.sso = sso;
const getSsoQueryKey = (hostingId, params) => [`/v1/hosting/${hostingId}/sso`, ...(params ? [params] : [])];
exports.getSsoQueryKey = getSsoQueryKey;
const useSso = (hostingId, params, options) => {
    var _a;
    const { query: queryOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_a = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _a !== void 0 ? _a : (0, exports.getSsoQueryKey)(hostingId, params);
    const queryFn = ({ signal }) => (0, exports.sso)(hostingId, params, Object.assign({ signal }, axiosOptions));
    const query = (0, react_query_1.useQuery)(queryKey, queryFn, Object.assign({ enabled: !!(hostingId) }, queryOptions));
    return Object.assign({ queryKey }, query);
};
exports.useSso = useSso;
/**
 * Returns site list.
 * @summary Site list for an account
 */
const sitesList = (options) => {
    return axios.default.get(`/v1/sites`, options);
};
exports.sitesList = sitesList;
const getSitesListQueryKey = () => [`/v1/sites`];
exports.getSitesListQueryKey = getSitesListQueryKey;
const useSitesList = (options) => {
    var _a;
    const { query: queryOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_a = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _a !== void 0 ? _a : (0, exports.getSitesListQueryKey)();
    const queryFn = ({ signal }) => (0, exports.sitesList)(Object.assign({ signal }, axiosOptions));
    const query = (0, react_query_1.useQuery)(queryKey, queryFn, queryOptions);
    return Object.assign({ queryKey }, query);
};
exports.useSitesList = useSitesList;
/**
 * Returns site information.
 * @summary info
 */
const sitesInfo = (siteId, options) => {
    return axios.default.get(`/v1/sites/${siteId}`, options);
};
exports.sitesInfo = sitesInfo;
const getSitesInfoQueryKey = (siteId) => [`/v1/sites/${siteId}`];
exports.getSitesInfoQueryKey = getSitesInfoQueryKey;
const useSitesInfo = (siteId, options) => {
    var _a;
    const { query: queryOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_a = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _a !== void 0 ? _a : (0, exports.getSitesInfoQueryKey)(siteId);
    const queryFn = ({ signal }) => (0, exports.sitesInfo)(siteId, Object.assign({ signal }, axiosOptions));
    const query = (0, react_query_1.useQuery)(queryKey, queryFn, Object.assign({ enabled: !!(siteId) }, queryOptions));
    return Object.assign({ queryKey }, query);
};
exports.useSitesInfo = useSitesInfo;
/**
 * Allows for updating a site's attributes
 * @summary site update
 */
const siteUpdate = (siteId, siteUpdateBody, options) => {
    return axios.default.put(`/v1/sites/${siteId}`, siteUpdateBody, options);
};
exports.siteUpdate = siteUpdate;
const useSiteUpdate = (options) => {
    const { mutation: mutationOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const mutationFn = (props) => {
        const { siteId, data } = props !== null && props !== void 0 ? props : {};
        return (0, exports.siteUpdate)(siteId, data, axiosOptions);
    };
    return (0, react_query_1.useMutation)(mutationFn, mutationOptions);
};
exports.useSiteUpdate = useSiteUpdate;
/**
 * Allows deleting a site
 * @summary site delete
 */
const site = (siteId, options) => {
    return axios.default.delete(`/v1/sites/${siteId}`, options);
};
exports.site = site;
const useSite = (options) => {
    const { mutation: mutationOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const mutationFn = (props) => {
        const { siteId } = props !== null && props !== void 0 ? props : {};
        return (0, exports.site)(siteId, axiosOptions);
    };
    return (0, react_query_1.useMutation)(mutationFn, mutationOptions);
};
exports.useSite = useSite;
/**
 * Returns the autoupdate status of the site's core, themes, and plugins
 * @summary settings autoupdates
 */
const sitesAutoupdatesInfo = (siteId, options) => {
    return axios.default.get(`/v1/sites/${siteId}/autoupdates`, options);
};
exports.sitesAutoupdatesInfo = sitesAutoupdatesInfo;
const getSitesAutoupdatesInfoQueryKey = (siteId) => [`/v1/sites/${siteId}/autoupdates`];
exports.getSitesAutoupdatesInfoQueryKey = getSitesAutoupdatesInfoQueryKey;
const useSitesAutoupdatesInfo = (siteId, options) => {
    var _a;
    const { query: queryOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_a = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _a !== void 0 ? _a : (0, exports.getSitesAutoupdatesInfoQueryKey)(siteId);
    const queryFn = ({ signal }) => (0, exports.sitesAutoupdatesInfo)(siteId, Object.assign({ signal }, axiosOptions));
    const query = (0, react_query_1.useQuery)(queryKey, queryFn, Object.assign({ enabled: !!(siteId) }, queryOptions));
    return Object.assign({ queryKey }, query);
};
exports.useSitesAutoupdatesInfo = useSitesAutoupdatesInfo;
/**
 * Enable / disable core, themes, or plugins autoupdates
 * @summary settings autoupdates toggle
 */
const sitesAutoupdatesUpdate = (siteId, sitesAutoupdatesUpdateBody, options) => {
    return axios.default.put(`/v1/sites/${siteId}/autoupdates`, sitesAutoupdatesUpdateBody, options);
};
exports.sitesAutoupdatesUpdate = sitesAutoupdatesUpdate;
const useSitesAutoupdatesUpdate = (options) => {
    const { mutation: mutationOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const mutationFn = (props) => {
        const { siteId, data } = props !== null && props !== void 0 ? props : {};
        return (0, exports.sitesAutoupdatesUpdate)(siteId, data, axiosOptions);
    };
    return (0, react_query_1.useMutation)(mutationFn, mutationOptions);
};
exports.useSitesAutoupdatesUpdate = useSitesAutoupdatesUpdate;
/**
 * Returns whether the site has either Codeguard or Jetpack-backup.
 * @summary has backup
 */
const sitesBackups = (siteId, options) => {
    return axios.default.get(`/v1/sites/${siteId}/backups`, options);
};
exports.sitesBackups = sitesBackups;
const getSitesBackupsQueryKey = (siteId) => [`/v1/sites/${siteId}/backups`];
exports.getSitesBackupsQueryKey = getSitesBackupsQueryKey;
const useSitesBackups = (siteId, options) => {
    var _a;
    const { query: queryOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_a = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _a !== void 0 ? _a : (0, exports.getSitesBackupsQueryKey)(siteId);
    const queryFn = ({ signal }) => (0, exports.sitesBackups)(siteId, Object.assign({ signal }, axiosOptions));
    const query = (0, react_query_1.useQuery)(queryKey, queryFn, Object.assign({ enabled: !!(siteId) }, queryOptions));
    return Object.assign({ queryKey }, query);
};
exports.useSitesBackups = useSitesBackups;
/**
 * The products supported jetpack-backup addon and jetpack-backup plugin
 * @summary Returns the status of the jetpack-backup product
 */
const jetpackBackupStatus = (siteId, options) => {
    return axios.default.get(`/v1/sites/${siteId}/backups/jetpack`, options);
};
exports.jetpackBackupStatus = jetpackBackupStatus;
const getJetpackBackupStatusQueryKey = (siteId) => [`/v1/sites/${siteId}/backups/jetpack`];
exports.getJetpackBackupStatusQueryKey = getJetpackBackupStatusQueryKey;
const useJetpackBackupStatus = (siteId, options) => {
    var _a;
    const { query: queryOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_a = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _a !== void 0 ? _a : (0, exports.getJetpackBackupStatusQueryKey)(siteId);
    const queryFn = ({ signal }) => (0, exports.jetpackBackupStatus)(siteId, Object.assign({ signal }, axiosOptions));
    const query = (0, react_query_1.useQuery)(queryKey, queryFn, Object.assign({ enabled: !!(siteId) }, queryOptions));
    return Object.assign({ queryKey }, query);
};
exports.useJetpackBackupStatus = useJetpackBackupStatus;
/**
 * Returns a list of DNS records for the site's domain.
 * @summary dns
 */
const sitesDns = (siteId, params, options) => {
    return axios.default.get(`/v1/sites/${siteId}/dns`, Object.assign({ params }, options));
};
exports.sitesDns = sitesDns;
const getSitesDnsQueryKey = (siteId, params) => [`/v1/sites/${siteId}/dns`, ...(params ? [params] : [])];
exports.getSitesDnsQueryKey = getSitesDnsQueryKey;
const useSitesDns = (siteId, params, options) => {
    var _a;
    const { query: queryOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_a = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _a !== void 0 ? _a : (0, exports.getSitesDnsQueryKey)(siteId, params);
    const queryFn = ({ signal }) => (0, exports.sitesDns)(siteId, params, Object.assign({ signal }, axiosOptions));
    const query = (0, react_query_1.useQuery)(queryKey, queryFn, Object.assign({ enabled: !!(siteId) }, queryOptions));
    return Object.assign({ queryKey }, query);
};
exports.useSitesDns = useSitesDns;
/**
 * Determines if the domain has the correct DNS setup for site
 * @summary Domain DNS setup for site
 */
const sitesDomain = (siteId, options) => {
    return axios.default.get(`/v1/sites/${siteId}/domain`, options);
};
exports.sitesDomain = sitesDomain;
const getSitesDomainQueryKey = (siteId) => [`/v1/sites/${siteId}/domain`];
exports.getSitesDomainQueryKey = getSitesDomainQueryKey;
const useSitesDomain = (siteId, options) => {
    var _a;
    const { query: queryOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_a = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _a !== void 0 ? _a : (0, exports.getSitesDomainQueryKey)(siteId);
    const queryFn = ({ signal }) => (0, exports.sitesDomain)(siteId, Object.assign({ signal }, axiosOptions));
    const query = (0, react_query_1.useQuery)(queryKey, queryFn, Object.assign({ enabled: !!(siteId) }, queryOptions));
    return Object.assign({ queryKey }, query);
};
exports.useSitesDomain = useSitesDomain;
/**
 * Add or promote pending site url
 * @summary Add pending site url
 */
const sitesDomainUrl = (siteId, sitesDomainUrlBody, options) => {
    return axios.default.post(`/v1/sites/${siteId}/domain`, sitesDomainUrlBody, options);
};
exports.sitesDomainUrl = sitesDomainUrl;
const useSitesDomainUrl = (options) => {
    const { mutation: mutationOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const mutationFn = (props) => {
        const { siteId, data } = props !== null && props !== void 0 ? props : {};
        return (0, exports.sitesDomainUrl)(siteId, data, axiosOptions);
    };
    return (0, react_query_1.useMutation)(mutationFn, mutationOptions);
};
exports.useSitesDomainUrl = useSitesDomainUrl;
/**
 * cache purge site and url
 * @summary cache purge url
 */
const sitesPerformanceCachepurge = (siteId, sitesPerformanceCachepurgeBody, options) => {
    return axios.default.post(`/v1/sites/${siteId}/performance/cachepurge`, sitesPerformanceCachepurgeBody, options);
};
exports.sitesPerformanceCachepurge = sitesPerformanceCachepurge;
const useSitesPerformanceCachepurge = (options) => {
    const { mutation: mutationOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const mutationFn = (props) => {
        const { siteId, data } = props !== null && props !== void 0 ? props : {};
        return (0, exports.sitesPerformanceCachepurge)(siteId, data, axiosOptions);
    };
    return (0, react_query_1.useMutation)(mutationFn, mutationOptions);
};
exports.useSitesPerformanceCachepurge = useSitesPerformanceCachepurge;
/**
 * Returns the status of endurance_cache_level
 * @summary Get status of endurance cache level
 */
const sitesPerformanceEnduranceCacheLevelStatus = (siteId, options) => {
    return axios.default.get(`/v1/sites/${siteId}/performance/endurance_cache_level`, options);
};
exports.sitesPerformanceEnduranceCacheLevelStatus = sitesPerformanceEnduranceCacheLevelStatus;
const getSitesPerformanceEnduranceCacheLevelStatusQueryKey = (siteId) => [`/v1/sites/${siteId}/performance/endurance_cache_level`];
exports.getSitesPerformanceEnduranceCacheLevelStatusQueryKey = getSitesPerformanceEnduranceCacheLevelStatusQueryKey;
const useSitesPerformanceEnduranceCacheLevelStatus = (siteId, options) => {
    var _a;
    const { query: queryOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_a = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _a !== void 0 ? _a : (0, exports.getSitesPerformanceEnduranceCacheLevelStatusQueryKey)(siteId);
    const queryFn = ({ signal }) => (0, exports.sitesPerformanceEnduranceCacheLevelStatus)(siteId, Object.assign({ signal }, axiosOptions));
    const query = (0, react_query_1.useQuery)(queryKey, queryFn, Object.assign({ enabled: !!(siteId) }, queryOptions));
    return Object.assign({ queryKey }, query);
};
exports.useSitesPerformanceEnduranceCacheLevelStatus = useSitesPerformanceEnduranceCacheLevelStatus;
/**
 * Set endurance cache level to 0, 1,2 or 3
 * @summary Set endurance cache level
 */
const sitesPerformanceEnduranceCacheLevel = (siteId, sitesPerformanceEnduranceCacheLevelBody, options) => {
    return axios.default.post(`/v1/sites/${siteId}/performance/endurance_cache_level`, sitesPerformanceEnduranceCacheLevelBody, options);
};
exports.sitesPerformanceEnduranceCacheLevel = sitesPerformanceEnduranceCacheLevel;
const useSitesPerformanceEnduranceCacheLevel = (options) => {
    const { mutation: mutationOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const mutationFn = (props) => {
        const { siteId, data } = props !== null && props !== void 0 ? props : {};
        return (0, exports.sitesPerformanceEnduranceCacheLevel)(siteId, data, axiosOptions);
    };
    return (0, react_query_1.useMutation)(mutationFn, mutationOptions);
};
exports.useSitesPerformanceEnduranceCacheLevel = useSitesPerformanceEnduranceCacheLevel;
/**
 * Update the endurance page cache
 * @summary update the endurance cache page
 */
const sitesPerformanceEndurancePageCache = (siteId, options) => {
    return axios.default.put(`/v1/sites/${siteId}/performance/endurance_page_cache`, undefined, options);
};
exports.sitesPerformanceEndurancePageCache = sitesPerformanceEndurancePageCache;
const useSitesPerformanceEndurancePageCache = (options) => {
    const { mutation: mutationOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const mutationFn = (props) => {
        const { siteId } = props !== null && props !== void 0 ? props : {};
        return (0, exports.sitesPerformanceEndurancePageCache)(siteId, axiosOptions);
    };
    return (0, react_query_1.useMutation)(mutationFn, mutationOptions);
};
exports.useSitesPerformanceEndurancePageCache = useSitesPerformanceEndurancePageCache;
/**
 * Returns a list of the site's plugins
 * @summary plugins
 */
const sitePlugins = (siteId, options) => {
    return axios.default.get(`/v1/sites/${siteId}/plugins`, options);
};
exports.sitePlugins = sitePlugins;
const getSitePluginsQueryKey = (siteId) => [`/v1/sites/${siteId}/plugins`];
exports.getSitePluginsQueryKey = getSitePluginsQueryKey;
const useSitePlugins = (siteId, options) => {
    var _a;
    const { query: queryOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_a = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _a !== void 0 ? _a : (0, exports.getSitePluginsQueryKey)(siteId);
    const queryFn = ({ signal }) => (0, exports.sitePlugins)(siteId, Object.assign({ signal }, axiosOptions));
    const query = (0, react_query_1.useQuery)(queryKey, queryFn, Object.assign({ enabled: !!(siteId) }, queryOptions));
    return Object.assign({ queryKey }, query);
};
exports.useSitePlugins = useSitePlugins;
/**
 * Enables / disables plugin auto-updates
 * @deprecated
 * @summary plugins autoupdate
 */
const sitePluginsAutoupdate = (siteId, sitePluginsAutoupdateBody, options) => {
    return axios.default.post(`/v1/sites/${siteId}/plugins/autoupdate`, sitePluginsAutoupdateBody, options);
};
exports.sitePluginsAutoupdate = sitePluginsAutoupdate;
const useSitePluginsAutoupdate = (options) => {
    const { mutation: mutationOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const mutationFn = (props) => {
        const { siteId, data } = props !== null && props !== void 0 ? props : {};
        return (0, exports.sitePluginsAutoupdate)(siteId, data, axiosOptions);
    };
    return (0, react_query_1.useMutation)(mutationFn, mutationOptions);
};
exports.useSitePluginsAutoupdate = useSitePluginsAutoupdate;
/**
 * Enables / disables a plugin
 * @summary plugins toggle
 */
const sitePluginsToggle = (siteId, sitePluginsToggleBody, options) => {
    return axios.default.post(`/v1/sites/${siteId}/plugins/toggle`, sitePluginsToggleBody, options);
};
exports.sitePluginsToggle = sitePluginsToggle;
const useSitePluginsToggle = (options) => {
    const { mutation: mutationOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const mutationFn = (props) => {
        const { siteId, data } = props !== null && props !== void 0 ? props : {};
        return (0, exports.sitePluginsToggle)(siteId, data, axiosOptions);
    };
    return (0, react_query_1.useMutation)(mutationFn, mutationOptions);
};
exports.useSitePluginsToggle = useSitePluginsToggle;
/**
 * Updates a plugin
 * @summary plugins update
 */
const sitePluginsUpdate = (siteId, sitePluginsUpdateBody, options) => {
    return axios.default.post(`/v1/sites/${siteId}/plugins/update`, sitePluginsUpdateBody, options);
};
exports.sitePluginsUpdate = sitePluginsUpdate;
const useSitePluginsUpdate = (options) => {
    const { mutation: mutationOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const mutationFn = (props) => {
        const { siteId, data } = props !== null && props !== void 0 ? props : {};
        return (0, exports.sitePluginsUpdate)(siteId, data, axiosOptions);
    };
    return (0, react_query_1.useMutation)(mutationFn, mutationOptions);
};
exports.useSitePluginsUpdate = useSitePluginsUpdate;
/**
 * Resets a site - deletes/reinstalls the site.
 * @summary reset site
 */
const resetSite = (siteId, options) => {
    return axios.default.post(`/v1/sites/${siteId}/reset`, undefined, options);
};
exports.resetSite = resetSite;
const useResetSite = (options) => {
    const { mutation: mutationOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const mutationFn = (props) => {
        const { siteId } = props !== null && props !== void 0 ? props : {};
        return (0, exports.resetSite)(siteId, axiosOptions);
    };
    return (0, react_query_1.useMutation)(mutationFn, mutationOptions);
};
exports.useResetSite = useResetSite;
/**
 * Performs a checksum of the site's core files to verify integrity.
 * @summary core files checksum
 */
const sitesSecurityCheckCore = (siteId, options) => {
    return axios.default.get(`/v1/sites/${siteId}/security/core/check`, options);
};
exports.sitesSecurityCheckCore = sitesSecurityCheckCore;
const getSitesSecurityCheckCoreQueryKey = (siteId) => [`/v1/sites/${siteId}/security/core/check`];
exports.getSitesSecurityCheckCoreQueryKey = getSitesSecurityCheckCoreQueryKey;
const useSitesSecurityCheckCore = (siteId, options) => {
    var _a;
    const { query: queryOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_a = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _a !== void 0 ? _a : (0, exports.getSitesSecurityCheckCoreQueryKey)(siteId);
    const queryFn = ({ signal }) => (0, exports.sitesSecurityCheckCore)(siteId, Object.assign({ signal }, axiosOptions));
    const query = (0, react_query_1.useQuery)(queryKey, queryFn, Object.assign({ enabled: !!(siteId) }, queryOptions));
    return Object.assign({ queryKey }, query);
};
exports.useSitesSecurityCheckCore = useSitesSecurityCheckCore;
/**
 * Resets the site's core files.
 * @summary core files reset
 */
const sitesSecurityResetCoreFiles = (siteId, options) => {
    return axios.default.post(`/v1/sites/${siteId}/security/core/reset`, undefined, options);
};
exports.sitesSecurityResetCoreFiles = sitesSecurityResetCoreFiles;
const useSitesSecurityResetCoreFiles = (options) => {
    const { mutation: mutationOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const mutationFn = (props) => {
        const { siteId } = props !== null && props !== void 0 ? props : {};
        return (0, exports.sitesSecurityResetCoreFiles)(siteId, axiosOptions);
    };
    return (0, react_query_1.useMutation)(mutationFn, mutationOptions);
};
exports.useSitesSecurityResetCoreFiles = useSitesSecurityResetCoreFiles;
/**
 * Returns the HTTPS redirection status.
 * @summary https redirection status
 */
const sitesSecurityHttpsRedirectionStatus = (siteId, options) => {
    return axios.default.get(`/v1/sites/${siteId}/security/https`, options);
};
exports.sitesSecurityHttpsRedirectionStatus = sitesSecurityHttpsRedirectionStatus;
const getSitesSecurityHttpsRedirectionStatusQueryKey = (siteId) => [`/v1/sites/${siteId}/security/https`];
exports.getSitesSecurityHttpsRedirectionStatusQueryKey = getSitesSecurityHttpsRedirectionStatusQueryKey;
const useSitesSecurityHttpsRedirectionStatus = (siteId, options) => {
    var _a;
    const { query: queryOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_a = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _a !== void 0 ? _a : (0, exports.getSitesSecurityHttpsRedirectionStatusQueryKey)(siteId);
    const queryFn = ({ signal }) => (0, exports.sitesSecurityHttpsRedirectionStatus)(siteId, Object.assign({ signal }, axiosOptions));
    const query = (0, react_query_1.useQuery)(queryKey, queryFn, Object.assign({ enabled: !!(siteId) }, queryOptions));
    return Object.assign({ queryKey }, query);
};
exports.useSitesSecurityHttpsRedirectionStatus = useSitesSecurityHttpsRedirectionStatus;
/**
 * Enables / disables HTTPS redirection.
 * @summary https redirection toggle
 */
const sitesSecurityHttpsEnableDisableSsl = (siteId, sitesSecurityHttpsEnableDisableSslBody, options) => {
    return axios.default.post(`/v1/sites/${siteId}/security/https`, sitesSecurityHttpsEnableDisableSslBody, options);
};
exports.sitesSecurityHttpsEnableDisableSsl = sitesSecurityHttpsEnableDisableSsl;
const useSitesSecurityHttpsEnableDisableSsl = (options) => {
    const { mutation: mutationOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const mutationFn = (props) => {
        const { siteId, data } = props !== null && props !== void 0 ? props : {};
        return (0, exports.sitesSecurityHttpsEnableDisableSsl)(siteId, data, axiosOptions);
    };
    return (0, react_query_1.useMutation)(mutationFn, mutationOptions);
};
exports.useSitesSecurityHttpsEnableDisableSsl = useSitesSecurityHttpsEnableDisableSsl;
/**
 * Returns the site's sitelock information.
 * @summary sitelock info
 */
const sitesSecuritySitelock = (siteId, options) => {
    return axios.default.get(`/v1/sites/${siteId}/security/sitelock`, options);
};
exports.sitesSecuritySitelock = sitesSecuritySitelock;
const getSitesSecuritySitelockQueryKey = (siteId) => [`/v1/sites/${siteId}/security/sitelock`];
exports.getSitesSecuritySitelockQueryKey = getSitesSecuritySitelockQueryKey;
const useSitesSecuritySitelock = (siteId, options) => {
    var _a;
    const { query: queryOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_a = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _a !== void 0 ? _a : (0, exports.getSitesSecuritySitelockQueryKey)(siteId);
    const queryFn = ({ signal }) => (0, exports.sitesSecuritySitelock)(siteId, Object.assign({ signal }, axiosOptions));
    const query = (0, react_query_1.useQuery)(queryKey, queryFn, Object.assign({ enabled: !!(siteId) }, queryOptions));
    return Object.assign({ queryKey }, query);
};
exports.useSitesSecuritySitelock = useSitesSecuritySitelock;
/**
 * Disables / enables cPanel to generate Let's Encrypt SSLs for the site.
 * @summary ssl lets encrypt toggle
 */
const sitesSecuritySslAcme = (siteId, options) => {
    return axios.default.post(`/v1/sites/${siteId}/security/ssl/acme`, undefined, options);
};
exports.sitesSecuritySslAcme = sitesSecuritySslAcme;
const useSitesSecuritySslAcme = (options) => {
    const { mutation: mutationOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const mutationFn = (props) => {
        const { siteId } = props !== null && props !== void 0 ? props : {};
        return (0, exports.sitesSecuritySslAcme)(siteId, axiosOptions);
    };
    return (0, react_query_1.useMutation)(mutationFn, mutationOptions);
};
exports.useSitesSecuritySslAcme = useSitesSecuritySslAcme;
/**
 * Returns the site's SSL Status
 * @summary ssl status
 */
const sitesSecuritySslStatus = (siteId, options) => {
    return axios.default.get(`/v1/sites/${siteId}/security/ssl/status`, options);
};
exports.sitesSecuritySslStatus = sitesSecuritySslStatus;
const getSitesSecuritySslStatusQueryKey = (siteId) => [`/v1/sites/${siteId}/security/ssl/status`];
exports.getSitesSecuritySslStatusQueryKey = getSitesSecuritySslStatusQueryKey;
const useSitesSecuritySslStatus = (siteId, options) => {
    var _a;
    const { query: queryOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_a = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _a !== void 0 ? _a : (0, exports.getSitesSecuritySslStatusQueryKey)(siteId);
    const queryFn = ({ signal }) => (0, exports.sitesSecuritySslStatus)(siteId, Object.assign({ signal }, axiosOptions));
    const query = (0, react_query_1.useQuery)(queryKey, queryFn, Object.assign({ enabled: !!(siteId) }, queryOptions));
    return Object.assign({ queryKey }, query);
};
exports.useSitesSecuritySslStatus = useSitesSecuritySslStatus;
/**
 * Returns status of plugin autoupdate for site
 * @deprecated
 * @summary plugins autoupdate status
 */
const siteSettingsAutoupdatePlugins = (siteId, options) => {
    return axios.default.get(`/v1/sites/${siteId}/settings/autoupdate/plugins`, options);
};
exports.siteSettingsAutoupdatePlugins = siteSettingsAutoupdatePlugins;
const getSiteSettingsAutoupdatePluginsQueryKey = (siteId) => [`/v1/sites/${siteId}/settings/autoupdate/plugins`];
exports.getSiteSettingsAutoupdatePluginsQueryKey = getSiteSettingsAutoupdatePluginsQueryKey;
const useSiteSettingsAutoupdatePlugins = (siteId, options) => {
    var _a;
    const { query: queryOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_a = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _a !== void 0 ? _a : (0, exports.getSiteSettingsAutoupdatePluginsQueryKey)(siteId);
    const queryFn = ({ signal }) => (0, exports.siteSettingsAutoupdatePlugins)(siteId, Object.assign({ signal }, axiosOptions));
    const query = (0, react_query_1.useQuery)(queryKey, queryFn, Object.assign({ enabled: !!(siteId) }, queryOptions));
    return Object.assign({ queryKey }, query);
};
exports.useSiteSettingsAutoupdatePlugins = useSiteSettingsAutoupdatePlugins;
/**
 * Returns the autoupdate status of the site's core, themes, and plugins
 * @deprecated
 * @summary settings autoupdates
 */
const sitesSettingsAutoupdates = (siteId, options) => {
    return axios.default.get(`/v1/sites/${siteId}/settings/autoupdates`, options);
};
exports.sitesSettingsAutoupdates = sitesSettingsAutoupdates;
const getSitesSettingsAutoupdatesQueryKey = (siteId) => [`/v1/sites/${siteId}/settings/autoupdates`];
exports.getSitesSettingsAutoupdatesQueryKey = getSitesSettingsAutoupdatesQueryKey;
const useSitesSettingsAutoupdates = (siteId, options) => {
    var _a;
    const { query: queryOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_a = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _a !== void 0 ? _a : (0, exports.getSitesSettingsAutoupdatesQueryKey)(siteId);
    const queryFn = ({ signal }) => (0, exports.sitesSettingsAutoupdates)(siteId, Object.assign({ signal }, axiosOptions));
    const query = (0, react_query_1.useQuery)(queryKey, queryFn, Object.assign({ enabled: !!(siteId) }, queryOptions));
    return Object.assign({ queryKey }, query);
};
exports.useSitesSettingsAutoupdates = useSitesSettingsAutoupdates;
/**
 * Enables WP Core autoupdates
 * @deprecated
 * @summary settings autoupdates core enable
 */
const sitesSettingsAutoupdatesCore = (siteId, sitesSettingsAutoupdatesCoreBody, options) => {
    return axios.default.post(`/v1/sites/${siteId}/settings/autoupdates/core`, sitesSettingsAutoupdatesCoreBody, options);
};
exports.sitesSettingsAutoupdatesCore = sitesSettingsAutoupdatesCore;
const useSitesSettingsAutoupdatesCore = (options) => {
    const { mutation: mutationOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const mutationFn = (props) => {
        const { siteId, data } = props !== null && props !== void 0 ? props : {};
        return (0, exports.sitesSettingsAutoupdatesCore)(siteId, data, axiosOptions);
    };
    return (0, react_query_1.useMutation)(mutationFn, mutationOptions);
};
exports.useSitesSettingsAutoupdatesCore = useSitesSettingsAutoupdatesCore;
/**
 * Enables theme autoupdates
 * @deprecated
 * @summary settings autoupdate theme enable
 */
const sitesSettingsAutoupdatesTheme = (siteId, sitesSettingsAutoupdatesThemeBody, options) => {
    return axios.default.post(`/v1/sites/${siteId}/settings/autoupdates/theme`, sitesSettingsAutoupdatesThemeBody, options);
};
exports.sitesSettingsAutoupdatesTheme = sitesSettingsAutoupdatesTheme;
const useSitesSettingsAutoupdatesTheme = (options) => {
    const { mutation: mutationOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const mutationFn = (props) => {
        const { siteId, data } = props !== null && props !== void 0 ? props : {};
        return (0, exports.sitesSettingsAutoupdatesTheme)(siteId, data, axiosOptions);
    };
    return (0, react_query_1.useMutation)(mutationFn, mutationOptions);
};
exports.useSitesSettingsAutoupdatesTheme = useSitesSettingsAutoupdatesTheme;
/**
 * Returns whether the coming soon setting is enable or disabled
 * @summary settings coming soon page status
 */
const sitesSettingsComingSoon = (siteId, options) => {
    return axios.default.get(`/v1/sites/${siteId}/settings/coming-soon`, options);
};
exports.sitesSettingsComingSoon = sitesSettingsComingSoon;
const getSitesSettingsComingSoonQueryKey = (siteId) => [`/v1/sites/${siteId}/settings/coming-soon`];
exports.getSitesSettingsComingSoonQueryKey = getSitesSettingsComingSoonQueryKey;
const useSitesSettingsComingSoon = (siteId, options) => {
    var _a;
    const { query: queryOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_a = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _a !== void 0 ? _a : (0, exports.getSitesSettingsComingSoonQueryKey)(siteId);
    const queryFn = ({ signal }) => (0, exports.sitesSettingsComingSoon)(siteId, Object.assign({ signal }, axiosOptions));
    const query = (0, react_query_1.useQuery)(queryKey, queryFn, Object.assign({ enabled: !!(siteId) }, queryOptions));
    return Object.assign({ queryKey }, query);
};
exports.useSitesSettingsComingSoon = useSitesSettingsComingSoon;
/**
 * Enables/disables the coming soon (under-construction) page
 * @summary settings coming soon toggle
 */
const sitesSettingsComingSoonToggle = (siteId, sitesSettingsComingSoonToggleBody, options) => {
    return axios.default.post(`/v1/sites/${siteId}/settings/coming-soon`, sitesSettingsComingSoonToggleBody, options);
};
exports.sitesSettingsComingSoonToggle = sitesSettingsComingSoonToggle;
const useSitesSettingsComingSoonToggle = (options) => {
    const { mutation: mutationOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const mutationFn = (props) => {
        const { siteId, data } = props !== null && props !== void 0 ? props : {};
        return (0, exports.sitesSettingsComingSoonToggle)(siteId, data, axiosOptions);
    };
    return (0, react_query_1.useMutation)(mutationFn, mutationOptions);
};
exports.useSitesSettingsComingSoonToggle = useSitesSettingsComingSoonToggle;
/**
 * Returns the site's debug mode status
 * @summary settings debug status
 */
const sitesSettingsDebug = (siteId, options) => {
    return axios.default.get(`/v1/sites/${siteId}/settings/debug`, options);
};
exports.sitesSettingsDebug = sitesSettingsDebug;
const getSitesSettingsDebugQueryKey = (siteId) => [`/v1/sites/${siteId}/settings/debug`];
exports.getSitesSettingsDebugQueryKey = getSitesSettingsDebugQueryKey;
const useSitesSettingsDebug = (siteId, options) => {
    var _a;
    const { query: queryOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_a = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _a !== void 0 ? _a : (0, exports.getSitesSettingsDebugQueryKey)(siteId);
    const queryFn = ({ signal }) => (0, exports.sitesSettingsDebug)(siteId, Object.assign({ signal }, axiosOptions));
    const query = (0, react_query_1.useQuery)(queryKey, queryFn, Object.assign({ enabled: !!(siteId) }, queryOptions));
    return Object.assign({ queryKey }, query);
};
exports.useSitesSettingsDebug = useSitesSettingsDebug;
/**
 * Enables or disables the output and display of site generated errors on the site
 * @summary settings debug toggle
 */
const sitesSettingsDebugToggle = (siteId, sitesSettingsDebugToggleBody, options) => {
    return axios.default.post(`/v1/sites/${siteId}/settings/debug`, sitesSettingsDebugToggleBody, options);
};
exports.sitesSettingsDebugToggle = sitesSettingsDebugToggle;
const useSitesSettingsDebugToggle = (options) => {
    const { mutation: mutationOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const mutationFn = (props) => {
        const { siteId, data } = props !== null && props !== void 0 ? props : {};
        return (0, exports.sitesSettingsDebugToggle)(siteId, data, axiosOptions);
    };
    return (0, react_query_1.useMutation)(mutationFn, mutationOptions);
};
exports.useSitesSettingsDebugToggle = useSitesSettingsDebugToggle;
/**
 * Updates the site's PHP version
 * @summary settings php version update
 */
const sitesSettingsPhpVersionUpdate = (siteId, sitesSettingsPhpVersionUpdateBody, options) => {
    return axios.default.post(`/v1/sites/${siteId}/settings/php-version`, sitesSettingsPhpVersionUpdateBody, options);
};
exports.sitesSettingsPhpVersionUpdate = sitesSettingsPhpVersionUpdate;
const useSitesSettingsPhpVersionUpdate = (options) => {
    const { mutation: mutationOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const mutationFn = (props) => {
        const { siteId, data } = props !== null && props !== void 0 ? props : {};
        return (0, exports.sitesSettingsPhpVersionUpdate)(siteId, data, axiosOptions);
    };
    return (0, react_query_1.useMutation)(mutationFn, mutationOptions);
};
exports.useSitesSettingsPhpVersionUpdate = useSitesSettingsPhpVersionUpdate;
/**
 * Gets the list of PHP versions available/installed
 * @summary settings php versions list
 */
const sitesSettingsPhpVersions = (siteId, options) => {
    return axios.default.get(`/v1/sites/${siteId}/settings/php-versions`, options);
};
exports.sitesSettingsPhpVersions = sitesSettingsPhpVersions;
const getSitesSettingsPhpVersionsQueryKey = (siteId) => [`/v1/sites/${siteId}/settings/php-versions`];
exports.getSitesSettingsPhpVersionsQueryKey = getSitesSettingsPhpVersionsQueryKey;
const useSitesSettingsPhpVersions = (siteId, options) => {
    var _a;
    const { query: queryOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_a = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _a !== void 0 ? _a : (0, exports.getSitesSettingsPhpVersionsQueryKey)(siteId);
    const queryFn = ({ signal }) => (0, exports.sitesSettingsPhpVersions)(siteId, Object.assign({ signal }, axiosOptions));
    const query = (0, react_query_1.useQuery)(queryKey, queryFn, Object.assign({ enabled: !!(siteId) }, queryOptions));
    return Object.assign({ queryKey }, query);
};
exports.useSitesSettingsPhpVersions = useSitesSettingsPhpVersions;
/**
 * Returns an SSO token or login URL for the site (if supported).
 * @summary sso
 */
const sitesSso = (siteId, params, options) => {
    return axios.default.get(`/v1/sites/${siteId}/sso`, Object.assign({ params }, options));
};
exports.sitesSso = sitesSso;
const getSitesSsoQueryKey = (siteId, params) => [`/v1/sites/${siteId}/sso`, ...(params ? [params] : [])];
exports.getSitesSsoQueryKey = getSitesSsoQueryKey;
const useSitesSso = (siteId, params, options) => {
    var _a;
    const { query: queryOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_a = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _a !== void 0 ? _a : (0, exports.getSitesSsoQueryKey)(siteId, params);
    const queryFn = ({ signal }) => (0, exports.sitesSso)(siteId, params, Object.assign({ signal }, axiosOptions));
    const query = (0, react_query_1.useQuery)(queryKey, queryFn, Object.assign({ enabled: !!(siteId) }, queryOptions));
    return Object.assign({ queryKey }, query);
};
exports.useSitesSso = useSitesSso;
/**
 * Returns a list of the site's users
 * @summary users
 */
const siteUsers = (siteId, options) => {
    return axios.default.get(`/v1/sites/${siteId}/users`, options);
};
exports.siteUsers = siteUsers;
const getSiteUsersQueryKey = (siteId) => [`/v1/sites/${siteId}/users`];
exports.getSiteUsersQueryKey = getSiteUsersQueryKey;
const useSiteUsers = (siteId, options) => {
    var _a;
    const { query: queryOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_a = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _a !== void 0 ? _a : (0, exports.getSiteUsersQueryKey)(siteId);
    const queryFn = ({ signal }) => (0, exports.siteUsers)(siteId, Object.assign({ signal }, axiosOptions));
    const query = (0, react_query_1.useQuery)(queryKey, queryFn, Object.assign({ enabled: !!(siteId) }, queryOptions));
    return Object.assign({ queryKey }, query);
};
exports.useSiteUsers = useSiteUsers;
/**
 * Returns site version information.
 * @summary version
 */
const sitesVersion = (siteId, options) => {
    return axios.default.get(`/v1/sites/${siteId}/version`, options);
};
exports.sitesVersion = sitesVersion;
const getSitesVersionQueryKey = (siteId) => [`/v1/sites/${siteId}/version`];
exports.getSitesVersionQueryKey = getSitesVersionQueryKey;
const useSitesVersion = (siteId, options) => {
    var _a;
    const { query: queryOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_a = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _a !== void 0 ? _a : (0, exports.getSitesVersionQueryKey)(siteId);
    const queryFn = ({ signal }) => (0, exports.sitesVersion)(siteId, Object.assign({ signal }, axiosOptions));
    const query = (0, react_query_1.useQuery)(queryKey, queryFn, Object.assign({ enabled: !!(siteId) }, queryOptions));
    return Object.assign({ queryKey }, query);
};
exports.useSitesVersion = useSitesVersion;
/**
 * List all SSH keys on a server or account. Finds all keys in user's .ssh/ diretory.
 * @summary ssh keys list
 */
const sshKeyListV2 = (hostingId, options) => {
    return axios.default.get(`/v2/hosting/${hostingId}/ssh/keys`, options);
};
exports.sshKeyListV2 = sshKeyListV2;
const getSshKeyListV2QueryKey = (hostingId) => [`/v2/hosting/${hostingId}/ssh/keys`];
exports.getSshKeyListV2QueryKey = getSshKeyListV2QueryKey;
const useSshKeyListV2 = (hostingId, options) => {
    var _a;
    const { query: queryOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_a = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _a !== void 0 ? _a : (0, exports.getSshKeyListV2QueryKey)(hostingId);
    const queryFn = ({ signal }) => (0, exports.sshKeyListV2)(hostingId, Object.assign({ signal }, axiosOptions));
    const query = (0, react_query_1.useQuery)(queryKey, queryFn, Object.assign({ enabled: !!(hostingId) }, queryOptions));
    return Object.assign({ queryKey }, query);
};
exports.useSshKeyListV2 = useSshKeyListV2;
